/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-white', 
    applyToParents: true,
    i18n: {
      scrollable: 'スクロールできます'
    }
  });

    //アコーディオン 【商品ページ 製品について】
    var productDescription = $('.product_description').find('.honey-td');
    productDescription.on('click',function(){
        $(this).toggleClass('js-active');
        
        if(!$(this).hasClass('js-active')){
            $(this).parent('.honey-tr').find('td').eq(1).slideToggle();
        } else {
            $(this).parent('.honey-tr').find('td').eq(1).slideToggle().css('display','block');
        }
    });

    //アコーディオン 【商品ページ　よくある質問】
    var productQa = $('.product_question').find('.question-td');
    productQa.on('click', function(){
        $(this).toggleClass('js-active');

        if(!$(this).hasClass('js-active')){
            $(this).parent('tr').find('.answer-td').slideToggle();
        } else {
            $(this).parent('tr').find('.answer-td').slideToggle().css('display','block');
        }
    });


    //【商品詳細ページ】定期購入ボタンの制御
    var num = 0;
    $('.huckleberry-subscription-widget-container').on('click' , function(){

        if($('input[id="subscription"]').prop("checked") == true) {
            //『定期決済』を選択したとき
            $('.not_member_btn').find('span').text('会員登録が必要な商品です');
            $('.not_member_btn').prop('disabled',true);
            $('.not_member_btn').addClass('hidden');
            $('.ProductForm__AddToCart_Second').removeClass('hidden');

            $('.subscription_link').removeClass('invisible');
            $('.subscription_slush').addClass('Price--compareAt');
            $('.discount_Price').removeClass('invisible');
            $('.ManukaSubsdcriptionBuybutton').addClass('invisible')

            $('.Product__SlideshowNavImage').removeClass('is-selected');
            $('.Product__SlideshowNavImage').eq(1).addClass('is-selected'); 
            $('.Product__SlideItem').removeClass('is-selected');
            $('.Product__SlideItem').eq(1).addClass('is-selected').removeClass('Product__SlideItem--hidden');

            $('.flickity-page-dots').find('button').removeClass('is-selected');
            $('.flickity-page-dots').find('button').eq(1).addClass('is-selected');
            $('.flickity-slider').css('transform','translateX(-100%)');
        } else if($('input[id="subscription"]').prop("checked") == false) {
            //『1回決済』を選択したとき
            $('.not_member_btn').find('span').text('カートに入れる');
            $('.not_member_btn').prop('disabled',false);
            $('.not_member_btn').removeClass('hidden');
            $('.ProductForm__AddToCart_Second').addClass('hidden');

            $('.subscription_link').addClass('invisible');
            $('.subscription_slush').removeClass('Price--compareAt');
            $('.discount_Price').addClass('invisible');
            $('.ManukaSubsdcriptionBuybutton').removeClass('invisible')

            $('.Product__SlideshowNavImage').removeClass('is-selected');
            $('.Product__SlideshowNavImage').eq(0).addClass('is-selected');
            $('.Product__SlideItem').removeClass('is-selected');
            $('.Product__SlideItem').eq(0).addClass('is-selected').removeClass('Product__SlideItem--hidden');
            $('.flickity-page-dots').find('button').removeClass('is-selected');
            $('.flickity-page-dots').find('button').eq(0).addClass('is-selected');
            $('.flickity-slider').css('transform','translateX(0%)');
        };
    });


    $(document).on('click', '#cart_privacy_check', function(){
        if($('#cart_privacy_check').prop('checked') == true){
            $('.cart_button').find('.button').prop('disabled',false);
            $('.cart_button').find('.button').addClass('checked');
        } else {
            $('.cart_button').find('.button').prop('disabled',true);
            $('.cart_button').find('.button').removeClass('checked');
        }
    });

    //プラセンタキャンペーン用　購入数2つまで制限

    $(function(){
        var $placentaNum = $('.Cart').find('.QuantitySelector__CurrentQuantity').val();
    
        if( $placentaNum !== "1" || $placentaNum !== "2"){
            $('.testtest').css('cssText','display:none !important');
        } else {
            alert('aa');
        }
    });

new ScrollHint('.js-scrollable');


  function copyCoupon() {
    const code = document.getElementById("couponCode").innerText;
    navigator.clipboard.writeText(code).then(function () {
      document.getElementById("copyMsg").style.display = "block";
      setTimeout(() => {
        document.getElementById("copyMsg").style.display = "none";
      }, 2000);
    }, function (err) {
      alert("コピーできませんでした");
    });
  }